import { useTranslation } from 'react-i18next';
import { Badge } from '@shared/ui';
import { productStatusTone, type ProductStatus } from '@entities/product';

export function ProductStatusChip({ status, title }: { status: ProductStatus; title?: string }) {
  const { t } = useTranslation();
  return (
    <Badge tone={productStatusTone(status)} title={title}>
      {t(`products.status.${status}`)}
    </Badge>
  );
}
